export default {
  partnerPoints: () => "partner-points",
  rewards: () => "loyalty-programs/rewards",
  loyaltyProgramVisits: () => "visits/loyalty",
}
